export default __webpack_public_path__ + "static/media/vd-screenshot-report.5c957db6.png";